module.exports = __webpack_public_path__ + "img/main_icon_staff.aa0f686.png";